<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="体检报告记录"
        left-arrow
        :fixed="true"
        @click-left="onClickLeft"
      />
      <div class="top"></div>
    </div>
    <div>
      <div v-if="showempty" class="empty">
      <van-empty description="暂无体检记录" />
    </div>
     <div   v-else class="main_body" style="flex:1;max-height:85vh;overflow: auto;"> 
     
      <div
        class="paycard"
        v-for="(item, index) in hispelist"
        :key="index"
      >
        <div class="head">
          <div>体检报告记录</div>
        
        </div>
        <div claass="content">
          <div class="Crow">
            <div>体检项目</div>
           <div>{{ item.CompanyName }}</div>
          </div>
          <div class="Crow">
            <div>体检号</div>
           <div>{{ item.CheckupNo }}</div>
          </div>
          <div class="Crow">
            <div>体检人</div>
            <div>{{ item.Name }}</div>
          </div>
          <div class="Crow">
            <div>体检时间</div>
            <div>{{ item.CretDate.substring(0, 10) }}</div>
          </div>
        
            <div class="Crow">
            <div>部门</div>
            <div>{{ item.Section }}</div>
          </div>
          <div class="Crow" >
            <div class="cancelBtn" @click="gopedetali(item.PersonalNo,item.CheckupNo,item.State)" >查看报告</div>
          </div>
    
        </div>

      </div>
     
     </div>
      <div style="padding:5px;" >
        <!-- <van-button @click="gocomparelist()"  round type="info" block>报告对比</van-button> -->
      </div>
    </div>

    <van-popup v-model="showcode" round :style="{ height: '35%' , width:'80%'}" closeable>
      <div class="popqrcode_box">
        <div class="popqrcode_text">体检号</div>
        <ProductQrcode :qrcode="qrcodestr" class="popqrcode"/>
        <div class="popqrcode_text">{{qrcodestr}}</div>
      </div>
    </van-popup>

  
  </div>
</template>

<script>
import Nav from "@/components/nav";
import ProductQrcode from '@/components/ProductQrcode'
import setOptions from "@/mixins/setOption";
import backindex from "@/mixins/backindex"
export default {
  mixins: [setOptions,backindex],
  components: {
    Nav,
    ProductQrcode
  },
  data() {
    return {
      showcode:false,
      showempty: false,
      name: "",
      clientId: "",
      hispelist: [],
      item: {},
      path: "",
      qrcodestr:"",
      RecordID:"",
      wx_pub_id:"",
      idno:""
    };
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    if (!this.$route.query.clientId) {
      this.$router.push("/patient_card_selectuser");
    }else{
      console.log(this.$route.query)
      this.idno=this.$route.query.item.IDCardNo
      this.clientId=this.$route.query.clientId
      this.getpereportinfo()
      // this.getrerinfo()
    }
    
  },
  methods: {
      //判断版本和排版类型
    //   async getrerinfo() {
    //   try {
    //     this.$showLoad();
    //     let url = "/hospitalconf/index/getdictionaries";
    //     await this.$axios_request.axios_request_body(
    //       "nodeserver",
    //       url,
    //       "POST",
    //       null,
    //       data => {
    //         this.$hideLoad();
    //         this.wx_pub_id = data.data.wx_pub_id;
    //         this.getpereportinfo()
          
    //       }
    //     );
    //   } catch (error) {
    //     // console.log(error);
    //     this.$hideLoad();
    //   }
    // },
    gocomparelist(){
      this.$router.push({
        path: "/comparelist",
        query: {
          clientId:this.clientId,
          idno:this.idno,
          wx_pub_id:this.wx_pub_id
        },
      });
    },
   gopedetali(PersonalNo,CheckupNo,State){
       this.$router.push({
        path: "/pereportdetail",
        query: {
          PersonalNo,
          CheckupNo,
          State
        },
      });
   },
  async getpereportinfo(){
    console.log(this.idno)
         try {
        this.$showLoad();
        let url = "/peisprecontroller/PEISQueryPersonalReportList";
        let R_data = {
          PersonalNo: this.idno,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          R_data,
          (data) => {
             this.$hideLoad();
            this.hispelist=data.data.data.Data
            if(this.wx_pub_id=="1018"){
              this.hispelist=this.hispelist.filter(item=>{
							return item.State=="5"||item.State=="6"
						})
            }else{
              this.hispelist=this.hispelist.filter(item=>{
							return item.State=="5"||item.State=="6"||item.State=="4"
						})
            }
         
            if( this.hispelist?.length===0||!data.data.data.Data){
             this.showempty=true
             console.log(111)
            }
            // this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
   },
    onClickLeft() {
      this.$router.push("/index");
    },
  
  
  
  },

};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .main_body{
    display: flex;
    flex-direction: column;

  }
  .popqrcode_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    .popqrcode {
      margin-top:5px ;
      margin-bottom: 8px;
    }
    .popqrcode_text {
      text-align: center;
      font-size: 16px;
    }
  }
  .top {
    height: 50px;
  }
  .paycard {
   
    background-color: #fafafa;
    padding: 5px;
    width: 93%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 8px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: 0 8px 12px #6666;
  }
  .last_item {
    margin-bottom: 60px;
    height: 1px;
  }
  .pay_list_foot {
    width: 100%;
    background-color: white;
    position: fixed;
    bottom: 0;
    border-top: 1px solid #aaaaaaaa;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    line-height: 70px;

    .pay_button {
      background-color: #5b8df6;
      margin-right: 20px;
      width: 95%;
      height: 40px;
      margin: 0px auto;
      line-height: 40px;
      border-radius: 5px;
      color: #ffffff;
      font-size:18px;
      letter-spacing: 5px;
    }
  }
  .head {
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #5b8df6;
    font-size: 16px;
    line-height: 40px;
  }
  .content {
    width: 90%;

    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 30px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
    .cancelBtn{
      width: 100%;
      text-align: center;
      font-size: 17px;
      margin-right: 5px;
      height: 30px;
      background-color: #5b8df6;
      border-radius: 15px;
      color: #ffffff;
    }
    .cancelBtna{
      width: 100%;
      text-align: center;
      font-size: 17px;
      margin-right: 5px;
      height: 30px;
      background-color: #999;
      border-radius: 15px;
      color: #ffffff;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
}
// 退费
// .refund_btn {
//   background-color: #5b8df6;
//   width: 70px;
//   margin-right: -5px;
//   height: 30px;
//   line-height: 30px;
//   border-radius: 5px;
//   color: #ffffff;
//   letter-spacing: 3px;
//   border: 0px;
// }
</style>
